import { render, staticRenderFns } from "./AdminResourceUsageLegacy.vue?vue&type=template&id=2b61c856"
import script from "./AdminResourceUsageLegacy.vue?vue&type=script&lang=js"
export * from "./AdminResourceUsageLegacy.vue?vue&type=script&lang=js"
import style0 from "./AdminResourceUsageLegacy.vue?vue&type=style&index=0&id=2b61c856&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports